import { SELECT_APPLICATION_ACCESS_LICENSE } from '../action-types';
import type { ILicenseSelectedState, ISelectedLicense, IPayloadAction } from '../interfaces';

export const initialState: ILicenseSelectedState = {
  license: {},
};

export const licenseSelectedReducer = (
  state: ILicenseSelectedState = initialState,
  action: IPayloadAction,
): ILicenseSelectedState => {
  switch (action.type) {
    case SELECT_APPLICATION_ACCESS_LICENSE:
      return {
        ...state,
        license: action.payload as ISelectedLicense,
      };
    default:
      return state;
  }
};
